/* eslint-disable no-restricted-imports */
import React, {type ReactNode, type HTMLAttributes} from 'react'
import clsx from 'clsx'
import styles from './FadeInContainer.module.scss'

export type FadeInContainerProps = {
    className?: string
    children: ReactNode
    animationDelayMs?: number | undefined
    animationDurationMs?: number | undefined
    animationPlayState?: 'running' | 'paused' | undefined
    disableAnimation?: boolean | undefined
} & HTMLAttributes<HTMLDivElement>
export const FadeInContainer = ({
    className = '',
    children,
    style,
    animationDelayMs = 0,
    animationDurationMs = 1000,
    animationPlayState = 'running',
    disableAnimation,
    ...props
}: FadeInContainerProps) => (
    <div
        className={clsx(styles.container, className)}
        style={{
            ...(disableAnimation
                ? {animation: 'none', opacity: 1}
                : {
                    animationDelay: `${animationDelayMs}ms`,
                    animationDuration: `${animationDurationMs}ms`,
                    animationPlayState: animationPlayState,
                }),
            ...style,
        }}
        {...props}>
        {children}
    </div>
)
